import { Item__Atividades } from "../../../../../../../../services/atividades/GET";


export function listarPatrimonios(lista_atividades: Item__Atividades[], data_atividades: Item__Atividades[]) {
    let estrututa = (lista_atividades ?? []).map(i => {
        //@ts-ignore
        let andamentos = i.andamentos?.flat();
        let patrimonios = andamentos?.filter(andamento => andamento.patrimonios?.length > 0)?.map(andamento => andamento.patrimonios)?.flat()
        return {
            descricao: i.cod_tipo === 1 ? i.descricao : (data_atividades ?? []).find(j => j.cod === i.cod_atividade)?.descricao,
            cod: i.cod,
            andamentos: andamentos,
            patrimonios: (patrimonios ?? []).map(j => {
                return {
                    ...j,
                    nome_atividade: i.cod_tipo === 1 ? i.descricao : (data_atividades ?? []).find(j => j.cod === i.cod_atividade)?.descricao,
                }
            })
        }
    });
    //@ts-ignore
    let estrutura__02 = (estrututa ?? []).map(i => i.patrimonios)?.flat()

    return estrutura__02 ?? []
}